import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';



import { inject, observer } from 'mobx-react';
import { Provider as KeepAliveProvider } from 'react-keep-alive';

import './App.css';
import Routes from "./router";

import Loading from '@/components/Loading/';
import Drawer from '@/components/Drawer/';
import { AppStore } from '@/store/';




@inject(stores => ({
    appStore: stores.appStore,
}))
@observer
class App extends Component {
    constructor(props) {
        super(props);
        this.drawer = null;
    }

    componentDidMount() {
        const path = window.location.pathname;
        if (path !== '/' && path !== '/map') {
            this.props.appStore.firstPageIsOk();
        }
        this.drawer = new window.mdui.Drawer(document.getElementById("drawer"), { swipe: true });
        // 第一次进入 打开侧边栏
        if (localStorage.isFirst != "no") this.drawer.open();
        localStorage.isFirst = "no";
        // 百度统计
        this.props.history.listen((location, action) => {
            window._hmt.push(['_trackPageview', location.pathname]);
        });
    }

    openMenu = () => {
        this.drawer.toggle();
        _hmt.push(["_trackEvent", "nav", "openMenu", "MainMenu"]);
    }

    render() {
        return (
            <>
                <Loading />
                <Drawer />
                <KeepAliveProvider>
                    <div className="main">
                        <div className="mdui-progress" id="progress">
                            <div className="mdui-progress-indeterminate"></div>
                        </div>
                        <button className="mdui-btn mdui-btn-icon" id="appBtn" onClick={this.openMenu}>
                            <i className="mdui-icon material-icons">menu</i>
                        </button>
                        <Routes />
                    </div>
                </KeepAliveProvider>
            </>
        );
    }
}
App.wrappedComponent.propTypes = {
    appStore: PropTypes.instanceOf(AppStore).isRequired,
    history: PropTypes.object.isRequired,
};

export default withRouter(App);
